import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDPrimaryActionButton,
  FDTextButton,
} from '@facet-wealth/design';
import MetaLayoutVertical from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutVertical';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { dataAttrs } from 'Helpers/Testing';
import { DialogActions, DialogTitle, DialogContent } from 'Views/Page/Content/Modal/Components';

function Layout() {
  const { onSubmit, resource } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();
  const { refreshPageContentCollection } = usePageContentContext();

  const handleCancel = () => {
    clearModalCollection();
  };

  const handleSubmit = async () => {
    await onSubmit();
    await refreshPageContentCollection();
    await clearModalCollection();
  };

  return (
    <>
      <DialogTitle value={'Edit Account'} />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <MetaLayoutVertical resource={resource} />
      </DialogContent>
      <DialogActions>
        <FDTextButton
          onClick={handleCancel}
          label="Cancel"
        />
        <FDPrimaryActionButton
          onClick={handleSubmit}
          label="Submit"
          {...dataAttrs('account-submit-btn')}
        />
      </DialogActions>
    </>
  );
}

Layout.defaultProps = {
};

Layout.propTypes = {
};

export default Layout;
